import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line
import Markdown from '../markdown';
import SVG from '../svg';
import { registerWidget } from './sections';

import CollapsibleTextStyles from './collapsible-text.styles';

/**
 *
 * @param {Object} props
 * @param {String} props.className
 * @param {String} props.id
 * @param {Object} props.options Passed to Markdown renderer
 * @param {String} props.text
 * @param {String} props.title
 */
const CollapsibleText = ({
  className,
  id,
  options,
  text,
  title,
}) => (
  <CollapsibleTextStyles>
    <div className={`CollapsibleText ${className}`}>
      <input
          type='checkbox'
          name='accordionToggle'
          id={`row${id}`}
          key={`input${id}`}
          aria-controls={`content${id}`} />
      <div className='row' id={`content${id}`} key={`content${id}`} role='tabpanel'>
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label className='titleText' htmlFor={`row${id}`}>
          <SVG id='chevron-bold' />
          <span className='text'>{title}</span>
        </label>
        <Markdown className='content' source={text} options={options} />
      </div>
    </div>
  </CollapsibleTextStyles>
);

CollapsibleText.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  options: PropTypes.object, // eslint-disable-line
};

CollapsibleText.defaultProps = {
  className: '',
  options: { html: true },
};


registerWidget('collapsibleTextSection', CollapsibleText);

export default CollapsibleText;
